import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './SoftwareVersionEditor.scss';
import BaseReactComponent from '../../Util/BaseReactComponent';
import baseComponent from '../../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import ProgressButton from '../../ProgressButton';
import { connect } from 'react-redux';
import update from 'react-addons-update';
import Modal from 'react-bootstrap/lib/Modal';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';
import {DropDownMenu, MenuItem} from 'material-ui';
import {uploadFile} from '../../../actioncreators/ZehnderActions.js';
import {Toggle} from 'material-ui';
import CountryDropDown from '../../Util/CountryDropDown';

@connect(state => ({
    user: state.login.user,
    products: state.zehnder.products
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class SoftwareVersionEditor extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.deleteMode = false;
        this.state.editMode = undefined;
        this.state.binary = this.props.binary || {};
        this.state.binaries = this.props.binaries || [];
    }

    onAddSoftwareVersion() {
        this.state.product = undefined;
        this.setState({
            product: undefined,
            productI: undefined,
            editMode: 'NEW',
            url: '',
            name: '',
            version: '',
            md5: '',
            beta: true,
            country: undefined
        });
    }

    editSoftwareVersion(swVersion) {
        if (swVersion) {
            swVersion.editMode = 'EDIT';

            //if(typeof swVersion.beta === 'boolean') {
            //  swVersion.beta = swVersion.beta === true? "true" : "false";
            //}
            this.setState(swVersion);

            this.state = swVersion;
        }
    }

    onSoftwareVersionDelete() {
        if (this.state.deleteMode) {
            this.props.deleteSoftwareVersion(this.state);

            this.setState({
                deleteMode: false
            });
        }
    }

    uploadBinary(file) {
      this.state.data = file;

      //let self = this;
      let reader = new FileReader();
      reader.onload = function () {
        //self.state.data.content = this.result;
      };
      reader.readAsText(file);

    }

    onSoftwareVersionAdd(v) {
        this.setState(Object.assign(this.state, v));
        if (this.state.url !== undefined && this.state.url !== '') {
            this.props.updateSoftwareVersion(this.state);
        } else {
          let file = this.refs.file.files[0];
          this.uploadBinary(file);
          let name = this.state.data.name.replace(' ', '_');

          let softwareVersion = {};
          Object.assign(softwareVersion, this.state);

          softwareVersion.size = this.state.data.size;
          softwareVersion.url = '/fw/' + this.state.country + '/' + this.state.product + '/' + this.state.version + "/" + name;

          this.props.addSoftwareVersion(softwareVersion, () => uploadFile('firmware', this.state.data, name, this.state.product, this.state.version, this.state.country)(this.props.dispatch));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.softwareVersion() !== undefined && (this.state.version !== nextProps.softwareVersion().version || this.state.editMode !== 'EDIT') && this.props.softwareVersion().editMode === 'EDIT') {
            this.editSoftwareVersion(this.props.softwareVersion());
            this.props.softwareVersion().editMode = undefined;
        } else
          if (nextProps.softwareVersion() !== undefined && this.props.softwareVersion().editMode === 'NEW') {
            this.onAddSoftwareVersion();
            this.props.softwareVersion().editMode = undefined;
        } else if (nextProps.softwareVersion() !== undefined) {
            this.state.binaries = nextProps.softwareVersion().binaries;
        }

        if (this.state.product !== undefined && this.state.product !== null) {
            let index = nextProps.products.findIndex(sw => {
                if (sw.productID === this.state.product.productID) {
                    return true;
                }
            });

            this.setState({
                productI: index
            });
        } else {
            this.setState({
                productI: undefined
            });
        }
    }

    componentWillUpdate() {

    }

    cancelEdit() {
        this.setState({
            editMode: undefined
        });

        this.props.changeTab(7);
    }

    startDeleteMode() {
        this.setState({
            deleteMode: true
        });
    }

    stopDeleteMode() {
        this.setState({
            deleteMode: false
        });
    }

    handleChange(key, event) {
        let newValue = {};
        newValue[key] = event.currentTarget.value;
        let newState = update(this.state, {$merge: newValue});
        this.setState(newState);
    }

    onToggle(key, event, value) {
      let newValue = {};
      newValue[key] = value;
      let newState = update(this.state, {$merge: newValue});
      this.setState(newState);
    }

    handleTabsChange(value) {
        this.props.changeTab(value);
    }

    handleVariantChange() {
        this.props.handleVariantChange();
    }

    pickedProduct(event, productI) {
        this.setState({'product': this.props.products[productI].productID});
        this.state.productI = productI;
    }

    onEditBinary(binary) {
        binary.editMode = 'EDIT';

        this.setState({
            binary: binary
        });

    }

    binaryAddNew(binary) {
        if (binary === undefined) {
            this.setState({
                binary: {
                    blockID: '',
                    name: '',
                    url: '',
                    size: undefined,
                    md5: '',
                    swVersion: this.state.id,
                    editMode: 'NEW'
                }
            });
        }
    }

    binaryToEdit() {
        return this.state.binary;
    }

    binaryUpdate(binary) {
        let self = this;

      if(binary.swVersion === undefined) {
        binary.swVersion = this.state;
      }

        this.props.binaryUpdate(binary, function(err) {
            if(!err) {
                binary.editMode = undefined;

                self.setState({
                    binary: binary
                });
            }
        });
    }

    binaryAdd(binary) {
        if (binary.swVersion === undefined) {
            binary.swVersion = this.state.id;
        }

        binary.editMode = undefined;

        this.setState({binary: binary});

        this.props.addBinary(binary);
    }

    cancelBinaryEdit() {
        if (this.state.binary.editMode === 'EDIT') {
            this.props.changeTab(8);
        }

        this.setState({
            binary: {
                editMode: undefined
            }
        });
    }

    deleteBinary() {
        let binary = this.state.binary;

        binary.editMode = undefined;
        binary.deleteMode = false;

        this.setState({
            binary: binary
        });

        this.props.deleteBinary(binary);
    }

    stopDeleteBinaryMode() {
        this.setState({
            binary: {
                deleteMode: false
            }
        });
    }

    keyup(e) {
        if (e.which === 13) {
            this.onSoftwareVersionAdd(e);
        }
    }

    onChange(type, event) {
      if (type === 'country') {
        this.setState({country: event});
      }
    }

    render() {
        let subTitle = this.getMessage(this.state.url !== undefined && this.state.url !== '' ? 'edit-softwareVersion' : 'add-softwareVersion');

        let deleteField = (<div className="form-group">
            <label htmlFor="address" className="col-sm-2 control-label">{this.getMessage('delete-label')}</label>

            <div className="col-sm-6 no-padding">
                <ProgressButton onClick={this.startDeleteMode.bind(this)}>{this.getMessage('delete-label')}</ProgressButton>
            </div>
        </div>);

        let css = {
          borderTop: "solid 1px #e0e0e0",
          bottom: "1px",
          left: "0",
          margin: "0",
          right: "0",
          position: "absolute"
        };

        let menuItems = this.props.products.map(function (product, index) {
            return <MenuItem key={index} value={index} primaryText={product.name}/>;
        });

        return (
            <div className="SoftwareVersionEditor">
                <div className="editor-header">
                    <div className="container">
                        <h1>{subTitle}</h1>
                    </div>
                </div>

                <Modal title="Delete user" onHide={this.stopDeleteMode.bind(this)} show={this.state.deleteMode}>
                    <Modal.Header>
                        {this.getMessage('delete-title')}
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            You are about to delete firmwareversion <b>{this.state.version}</b><br/>
                            Are you sure?
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <a className="btn btn-link" onClick={this.stopDeleteMode.bind(this)}>{this.getMessage('cancel-button')}</a>
                        <a className="btn btn-primary" onClick={this.onSoftwareVersionDelete.bind(this)}>{this.getMessage('delete-label')}</a>
                    </Modal.Footer>
                </Modal>

                <div className="container">
                    <Form role="form" className="form-horizontal" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.onSoftwareVersionAdd.bind(this)}>
                        <div className="form-group">
                            <label htmlFor="username" className="col-sm-2 control-label">{this.getMessage('version-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="version"
                                                type="text"
                                                className="validate"
                                                id="version"
                                                onChange={this.handleChange.bind(this, 'version')}
                                                value={this.state.version}
                                                validate={(val) => {
                                                            return /^([UDPR]?)(\d+)\.(\d+)\.(\d+)$/.test(val);
                                                        }}
                                                errorHelp="Version must be like U1.2.3, D12.33.4 P32.0.1 R1.1.1 or 3.2.1"
                                    />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('name-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="name"
                                                type="text"
                                                className="validate"
                                                value={this.state.name}
                                                id="name"
                                                onChange={this.handleChange.bind(this, 'name')}
                                    />
                            </div>
                        </div>

                      <div className="form-group">
                        <label htmlFor="country" className="col-sm-2 control-label">{this.getMessage('country-label')}</label>

                        <div className="col-sm-6 no-padding">
                          <CountryDropDown className="validate form-control" id="country" onChange={this.onChange.bind(this)} edit={true} country={this.state.country} includeAllCountries={true}/>
                        </div>
                      </div>

                      {this.state.url !== undefined && this.state.url !== '' ? <div></div> : (
                        <div>
                          <div className="form-group">
                            <label htmlFor="username" className="col-sm-2 control-label">{this.getMessage('md5-label')}</label>

                            <div className="col-sm-6">
                              <ValidatedInput name="md5"
                                              type="text"
                                              className="validate"
                                              id="name"
                                              value={this.state.md5}
                                              onChange={this.handleChange.bind(this, 'md5')}
                                              validate="required"
                                              errorHelp={{
                                      required: 'Please enter an md5 for this binary'
                                    }}
                                />
                            </div>
                          </div>
                          <div className="form-group card-panel">
                            <label htmlFor="binary" className="col-sm-2 control-label">{this.getMessage('binary-label')}</label>

                            <div className="col-sm-6 form-group">
                              <div className="FileUpload-input file-field input-field controls">
                                <div className="btn btn-primary">
                                  <input ref="file" type="file"/>
                                  <span>{this.getMessage('choose-binary')}</span>
                                </div>
                                <div className="file-path-wrapper">
                                  <input className="file-path validate form-control" type="text"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>)}

                        <div className="form-group">
                            <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('product-label')}</label>

                            <div className="col-sm-6 no-padding dropdown-choice">
                                <DropDownMenu onChange={this.pickedProduct.bind(this)} autoWidth={true} value={this.state.productI} underlineStyle={css}>
                                    {menuItems}
                                </DropDownMenu>
                            </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('beta-label')}</label>

                          <div className="col-sm-6" style={{paddingTop: '7px'}} >
                            <Toggle onToggle={this.onToggle.bind(this, 'beta')} toggled={this.state.beta}/>
                          </div>
                        </div>

                        {this.state.url !== undefined && this.state.url !== ''? deleteField : (<div></div>)}
                        <div className="controls">
                            <button className="btn btn-primary">{this.getMessage('save-button')}</button>
                            <a className="btn btn-link" onClick={this.cancelEdit.bind(this)}>{this.getMessage('cancel-button')}</a>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

SoftwareVersionEditor.propTypes = {
    softwareVersion: React.PropTypes.func,
    changeTab: React.PropTypes.func,
    updateSoftwareVersion: React.PropTypes.func,
    addSoftwareVersion: React.PropTypes.func,
    deleteSoftwareVersion: React.PropTypes.func,
    onEditSoftwareVersion: React.PropTypes.func
};

SoftwareVersionEditor.defaultProps = {
    componentName: 'softwareVersion-editor'
};

export default SoftwareVersionEditor;



// WEBPACK FOOTER //
// /src/components/SoftwareVersion/SoftwareVersionEditor/SoftwareVersionEditor.js